module.exports = __webpack_public_path__ + "static/fourth-cc4b870bc0279e435f48a74e8399fed8.svg";